import { useTheme } from "@mui/material";
import React from "react";

type Props = {
  icon: React.ReactNode;
  selected?: boolean;
};

export default function MenuIcon({ icon, selected }: Props) {
  const isDarkMode = useTheme().palette.mode === "dark";
  if (typeof icon !== "string") return icon;
  const folder = isDarkMode ? "dark/" : "";
  const url = selected
    ? `/menu-icons/${folder}${icon}_Selected.svg`
    : `/menu-icons/${folder}${icon}_Default.svg`;
  return (
    <img
      loading="lazy"
      decoding="async"
      src={url}
      alt=""
      width={24}
      height={24}
    />
  );
}
